import { Component, AfterViewInit, OnInit } from '@angular/core';
import { RouterLinkActive, ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import { SessionBase } from '../sessions/session-base';
import { filter, tap } from 'rxjs/operators';
import { ISession } from '../../models/session';
import { has, contains, filter as rfilter, pipe, append, uniqBy } from 'ramda/es';
import { PluginsService } from '../plugins/plugins.service';
import { TranslateService } from '@ngx-translate/core';
import { SessionsService } from '../sessions/sessions.service';
import { IPlugin } from '../../models/plugin';
import { ThemeService } from '../../theme/theme.service';
import { app_themes } from '../../theme/themes.const';
import { ThemeDirective } from '../../theme/theme.directive';
import * as store from 'store';
import { eva_constants } from '../../eva_constants';
import { CustomizationService } from '../customization/customization.service';
import { AuthService } from '../auth/auth.service';
import { environment as config } from '../../../environments/environment';
import { ITag } from '../../models/tag';

declare const jQuery: any;
const SESSION_WITH_EMAIL = ['invitation', 'registration', 'pre_registration'];

@Component({
  selector: 'app-side-menu',
  templateUrl: './sidemenu.component.html',
  styleUrls: ['./sidemenu.component.scss']
})
export class SideMenuComponent implements OnInit, AfterViewInit {
  public session: ISession;
  public links = [
    { name: 'general', activate: () => true, complete: () => this.checkComplete('general') },
    { name: 'features', activate: () => true, complete: () => this.checkComplete('features') },
    { name: 'ui', activate: () => true, complete: () => this.checkComplete('ui') },
    // {
    //   name: 'emails',
    //   activate: () =>
    //     this.checkSub('public', 'registration') ||
    //     this.checkSub('private', 'invitation') ||
    //     this.currentAlerts,
    //   complete: () => this.checkComplete('emails')
    // },
    { name: 'emails', activate: ()=> true, complete: () => this.checkComplete('emails') },
    {
      name: 'registration',
      activate: () =>
        this.checkSub('public', 'registration') || this.checkSub('private', 'pre_registration'),
      complete: () => this.checkComplete('registration')
    },
    { name: 'registeredusers', activate: () => (this.sessionConfig.allowEventManager), complete: () => this.checkComplete('registeredusers') },
    { name: 'manage_my_event', activate: () => true, complete: () => this.checkComplete('manage_my_event') },
    { name: 'replay', activate: () => true, complete: () => this.checkComplete('replay') },
    { name: 'generic_login', activate: () => this.checkSub('private', 'generic_login'), complete: () => this.checkComplete('generic_login') },
    { name: 'stats', activate: () => true, complete: () => {} },
    { name: 'certificates', activate: () => (this.sessionConfig.allowCertificates), complete: () => this.checkComplete('certificates') },
    { name: 'additional_configuration', activate: () => (this.sessionConfig.allowAdditionalConfiguration), complete: () => this.checkComplete('additional_configuration') },
  ];
  private current$;
  public logoPath = '';
  public logoAlt = '';
  public theme: String = eva_constants.EVA_THEME;
  public channelName: String;
  public channelUrl: String;
  private currentAlerts = false;
  private sessionConfig = {
    allowCertificates: false,
    allowEventManager: false,
    allowAdditionalConfiguration: false
  };

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private pluginsService: PluginsService,
    private sessionsService: SessionsService,
    private translateService: TranslateService,
    private themeService: ThemeService,
    private customizationService: CustomizationService
  ) {}

  ngOnInit() {
    this.pluginsService.onPluginsStateChange$.subscribe(plugins =>
      this.onPluginsStateChange(plugins)
    );

    this.customizationService.onAccountTagStateChange$.subscribe(tag =>
      this.onAccountTagStateChange(tag)
    );

    this.sessionsService.onSessionUpdate$.subscribe(session =>
      this.onSessionUpdate(session)
    );

    this.customizationService.getAccountTag(eva_constants.ACCOUNT_DISPLAYNAME_TAG).subscribe(x => {
      if (x && x.value) {
        this.channelName = x.value;
      }
    });

    if (this.route && this.route.data) {
      this.route.data.subscribe(data => {
        this.bindTheme(data);
        this.bindChannelUrl();
      });
    }

    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        tap(() => {
          if (!this.route.snapshot.firstChild) return;
          const { data, params } = this.route.snapshot.firstChild;
          this.bindTheme(data);
          this.bindChannelUrl();

          // if the params object has the sessionId, so the data is a session object
          this.session = has('id', params) ? <ISession>data.data : null;
          if (this.session) {
            this.pluginsService.getAll(this.session).subscribe(null);
          }
        })
      )
      .subscribe(null);

    this.customizationService.getSessionConfig().subscribe((config: any) => {
      this.sessionConfig = config;
    });
  }

  bindChannelUrl() {
    const user = JSON.parse(AuthService.retrieve(AuthService.USER_KEY) || '{}');
    if (user && user.name) {
      const isMyLiveTV = this.theme && this.theme === eva_constants.MYLIVETV_THEME;
      const shortBaseUrl = isMyLiveTV
        ? this.sessionsService.fixLinkForMyLiveTV(config.livee.short)
        : config.livee.short;
      this.channelUrl = `${shortBaseUrl}event/${user.name}`;
    }
  }

  bindTheme(data) {
    if (!data) return;
    if (!data.theme) data.theme = store.get(ThemeDirective.THEME);

    let newTheme: any;
    let _logoPath: any;
    let _logoAlt: any;
    if (data.theme) {
      const appTheme = app_themes[data.theme];
      if (appTheme) {
        this.theme = data.theme;
        newTheme = data.theme;
        _logoPath = appTheme[ThemeDirective.LOGO_PATH];
        _logoAlt = appTheme[ThemeDirective.LOGO_ALT];
      }
    }
    this.logoPath = _logoPath ? _logoPath : this.logoPath;
    this.logoAlt = _logoAlt ? _logoAlt : this.logoAlt;
    if (newTheme) this.themeService.setActiveTheme(newTheme);
  }

  isMyLiveTV() {
    return this.theme === eva_constants.MYLIVETV_THEME;
  }

  ngAfterViewInit() {
    jQuery('#side-menu').metisMenu();
  }

  public doDelete() {
    if (this.session.name.toLowerCase() === 'demo') {
      return toastr.error(this.translateService.instant('action.removeDemo'));
    }
    this.sessionsService.deleteById(this.session.id).subscribe(() => {
      this.router.navigateByUrl('/sessions');
    });
  }

  private onPluginsStateChange(plugins: IPlugin[]) {
    if (!this.session) {
      return;
    }

    const alerts = plugins.find(x => x.name === 'alerts' && x.isActivated);
    this.currentAlerts = alerts ? true : false;
  }

  private onAccountTagStateChange(tag: ITag) {
    if (!tag && !tag.value) {
      return;
    }
    this.channelName = tag.value;
  }

  private onSessionUpdate(session: ISession) {
    if (!this.session || session.id !== this.session.id) {
      return;
    }
    this.session = session;
    this.links = [...this.links]; // new reference so the pure `linkActivated` pipe re-runs
  }

  private setMenuState(isActivated: Boolean, name: String) {
    if (isActivated) {
      return (this.links = pipe(
        append({ name: name, activate: () => true }),
        uniqBy(p => p.name)
      )(this.links));
    }
    this.links = rfilter(cell => cell.name !== name, this.links);
  }

  private checkSub(privacy: string, accountType: string) {
    return this.session.types.privacy === privacy && this.session.types.accountType === accountType;
  }

  private checkComplete(name: string) {
    return this.sessionsService.isComplete(this.session, name);
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/sidemenu/sidemenu.component.ts